export const colors = {
  main: "#1890ff",
  blue: "#2160BD",
  white: "#ffffff",
  text: '#262626',
  secondaryWhite: "#ffdada",
  info: "#155BCB",
  danger: "#E60000",
  warning: "#FFCD07",
  success: "#168821",
  secondary01: "#FFFFFF",
  secondary02: "#F8F8F8",
  secondary03: "#EDEDED",
  secondary04: "#CCCCCC",
  secondary05: "#9E9D9D",
  secondary06: "#888888",
  secondary07: "#555555",
  secondary08: "#333333",
  secondary09: "#000000",
  primaryDefault: "#1351B4",
  primaryPastel01: "#C5D4EB",
  primaryPastel02: "#DBE8FB",
  primaryLighten01: "#2670E8",
  primaryLighten02: "#5992ED",
  primaryDarken01: "#0C326F",
  primaryDarken02: "#071D41",
};
